import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AlertContext from '../../../../context/AlertContext';
import { getPDFApply } from '../../eDocumentsSlice';
import { formatNumber } from '../../../../common/Util';

const NtsResult_09 = () => {
  const dispatch = useDispatch();
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const { ntsResult } = useSelector(state => state.eDocuments);
  const [tableData01, setTableData01] = useState([]);

  useEffect(() => {
    createTableData();
  }, []);

  const createTableData = async () => {
    try {
      const resultAPI = await dispatch(getPDFApply({ htmPCd: '9' })).unwrap();
      if (resultAPI != undefined) {
        if (resultAPI.list != undefined) {
          let _tableData01 = [];
          let total01 = 0;
          let total02 = 0;
          resultAPI.list.map((item, index) => {
            if (index == 0 && item.htmMm2 == undefined) {
              _tableData01[0] = {
                htmMm2: '추납보험료 납부금액',
                htm007: '',
                htm008: item.htm003,
              };
              _tableData01[1] = {
                htmMm2: '실업크레딧 납부금액',
                htm007: '',
                htm008: item.htm004,
              };
              _tableData01[2] = {
                htmMm2: '직장가입자 소급고지금액',
                htm007: item.htm009,
                htm008: '',
              };

              total01 += parseInt(item.htm009.replaceAll(',', ''));
              total02 +=
                parseInt(item.htm003.replaceAll(',', '')) +
                parseInt(item.htm004.replaceAll(',', ''));
            } else if (item.htmMm2) {
              // 월별 데이터는 5번 인덱스부터 시작하도록 (합계 및 총합계가 3, 4 인덱스이므로)
              const monthIndex = parseInt(item.htmMm2) + 4;
              _tableData01[monthIndex] = item;

              if (item.htm007 != undefined) total01 += parseInt(item.htm007.replaceAll(',', ''));
              if (item.htm008 != undefined) total02 += parseInt(item.htm008.replaceAll(',', ''));
            }
          });

          _tableData01[3] = {
            htmMm2: '합계',
            htm007: formatNumber(total01),
            htm008: formatNumber(total02),
          };
          _tableData01[4] = {
            htmMm2: '총합계',
            total: formatNumber(total01 + total02),
          };
          setTableData01(_tableData01);
        }
      } else {
        alertMessage('데이터가 없습니다. ', 'error');
      }
    } catch (e) {
      console.log('e >>', e);
      alertMessage('오류가 발생하였습니다. ', 'error');
    } finally {
      // setBackDrop(false);
    }
  };

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>국민연금보험료</p>
        <Table01 bodyList={tableData01} />
      </div>
    </div>
  );
};

export default NtsResult_09;

const Table01 = ({ bodyList }) => {
  const headList = [
    { name: '월', width: '30%', key: 'htmMm2' },
    { name: '직장가입자 고지금액', width: '35%', key: 'htm007', align: 'right' },
    { name: '지역가입자 등 납부금액', width: '35%', key: 'htm008', align: 'right' },
  ];

  return (
    <div className={'yearendManualContentsBox'}>
      <div className={'ntsResultBox'}>
        <div>
          <div className="displayFlex tableTr">
            {headList.map((item, index) => (
              <div
                className="tableTitle captionBold"
                style={{
                  flex: 'none',
                  width: item.width,
                  justifyContent: item.align,
                }}
                key={index}>
                {item.name}
              </div>
            ))}
          </div>
          {bodyList.map((item, index) =>
            index != 4 ? (
              <div className="displayFlex tableTr" key={index}>
                {headList.map((_item, _index) => (
                  <div
                    className="tableBody captionMedium"
                    key={_index}
                    style={{
                      width: _item.width,
                      flex: 'none',
                      justifyContent: _item.align,
                    }}>
                    {item[_item.key]}
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="displayFlex tableTr"
                key={index}
                style={{ backgroundColor: 'var(--Primary-100)' }}>
                <div
                  className="tableBody captionBold"
                  style={{
                    flex: 'none',
                    width: '30%',
                  }}>
                  {item.htmMm2}
                </div>
                <div
                  className="tableBody captionBold"
                  style={{
                    flex: 1,
                    justifyContent: 'right',
                  }}>
                  {item.total}
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};
